import { Component, Prop, Mixins } from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Table Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Title of the table
     */
    @Prop() title!: string;

    /**
     * Table Header titles
     */
    @Prop({ type: Array, default: () => [] }) headerTitles!: Array<any>;

    /**
     * Table rows
     */
    @Prop({ type: Array, default: () => [] }) rows!: Array<any>;

    /**
     * Table footer titles
     */
    @Prop({ type: Array, default: () => [] }) footerTitles!: Array<any>;

    /**
     * Caption of the table
     */
    @Prop() caption!: string;

    /**
     * Caption position in table
     * position: `bottom`, `top`
     */
    @Prop({ type: String, default: 'bottom' }) captionPosition!: string;

    /**
     * Enable striped
     */
    @Prop({ type: Boolean }) striped!: boolean;

    /**
     * Type of striped
     * Type: `row` or `column`
     */
    @Prop({ type: String, default: 'row' }) stripedType!: string;

    /**
     * Enable striped for odd columns or odd rows
     */
    @Prop({ type: Boolean }) stripedOdd!: boolean;

    /**
     * Enable striped for even columns or even rows
     */
    @Prop({ type: Boolean }) stripedEven!: boolean;

    /**
     * Set border for columns
     */
    @Prop({ type: Boolean }) borderedColumn!: boolean;

    /**
     * Set border for rows
     */
    @Prop({ type: Boolean }) borderedRow!: boolean;

    /**
     * Remove border from around the table
     */
    @Prop({ type: Boolean }) noBorder!: boolean;

    /**
     * Set background to header
     */
    @Prop() headerColor!: string;

    /**
     * Set background Palette to header Color
     */
    @Prop() headerColorPalette!: string;
}

export default Props;
